// extracted by mini-css-extract-plugin
module.exports = {"reviewPageContainer":"SharePriceTable_reviewPageContainer__3dK5H","balanceTable":"SharePriceTable_balanceTable__2HtyM","timerColumn":"SharePriceTable_timerColumn__2OeFB"};